<template>
    <div style="display: inline-block;">
        <van-icon
            name="info-o"
            class="cell-right-icon"
            @click="showAmtDetail()"
        />
        <van-dialog
            v-model="showAmtDetailDialog"
            :title="`${payment_way_desc}${detailTitle}明细`"
            confirmButtonText="确认"
            getContainer=".page-wrap"
            class="fee-detail-dialog"
        >
        <van-list>
            <van-cell
                v-for="item in amtDetailItems"
                :key="item.name"
                :title="item.name"
                v-if="!item.seq"
                :value="typeof(item.amt) === 'number' ? item.amt + ' 元' : item.amt"
            />
            
            <van-cell
                class="sep-detail-item"
                v-for="item in amtDetailItems"
                :key="item.name"
                :title="item.name"
                v-if="item.seq"
                :value="typeof(item.amt) === 'number' ? item.amt + ' 元' : item.amt"
            />
            <van-cell v-if="detailTotal >= 0">
                <template>
                    <div style="text-align:right;">合计缴费：{{detailTotal}}元</div>
                </template>
            </van-cell>
        </van-list>
        </van-dialog>
    </div>
</template>
<script>
export default {
  name: "sby-info",
  methods: {
    showAmtDetail() {
      this.showAmtDetailDialog = true;
    },
  },
  mounted() {
  },
  data: function() {
    return {
      showAmtDetailDialog: false,
    };
  },
  props: {
    payment_way_desc: {
      type: String,
      default: ''
    },
    detailTitle: {
      type: String,
      default: ''
    },
    detailTotal: {
      type: Number,
      default: 0
    },
    amtDetailItems: {
      type: Array,
      default: () => {
        return [];
      },
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/sby-info.vue